import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams, LoadingController, AlertController, ModalController, ModalOptions } from 'ionic-angular';

import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import {BusquedaPage} from '../../pages/busqueda/busqueda'

/**
 * Generated class for the EntidadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-entidad',
  templateUrl: 'entidad.html',
})
export class EntidadPage {

  objEntidad:any={};
  loading: any;
  detalleBusqueda: any;
  tentidad : any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, 
  	public servicio: EntidadServiceProvider, public modalCtrl: ModalController,
  	public loadingCtrl:LoadingController, public alertCtrl: AlertController) {
  	
    this.servicio.idtentidad = this.navParams.get('idtentidad');
    this.tentidad= this.servicio.idtentidad == 1 ? 'Operador' : (this.servicio.idtentidad == 2 ? 'Condómino' : 'Proveedor');
  }

  ionViewDidLoad() {
    this.botonNuevo();
  }

  botonNuevo(){
  	this.objEntidad.id=0;
  	this.objEntidad.idempresa=1;
  	this.objEntidad.descripcion='';
  	this.objEntidad.direccion1='';
  	this.objEntidad.telefono1='';
  	this.objEntidad.idestado=0;
  	this.objEntidad.correo='';
  	this.objEntidad.idtentidad=this.navParams.get('idtentidad');
  	this.objEntidad.tentidad= this.navParams.get('idtentidad') == 1 ? 'Operador' : 'Condómino';
  	this.objEntidad.identificacion='';
  	this.objEntidad.codigo='';
  	this.objEntidad.idtidentificacion=1;
  	this.objEntidad.idgrupociudad=null;
  	this.objEntidad.idgrupoestado=null;
  	this.objEntidad.plazo=0;
  	this.objEntidad.razonsocial='';
  	this.objEntidad.idgrupozona=null;
  	this.objEntidad.idgrupocateg=null;
  	this.objEntidad.idestadocivil=0;
  	this.objEntidad.idgenero=0;
  	this.objEntidad.idtjuridica=null;
  	this.objEntidad.idanexo=null;
  	this.objEntidad.fecnacimiento=null;
  	this.objEntidad.telefonob='';
  	this.objEntidad.telefonoc='';
  	this.objEntidad.contacto_des='';
  	this.objEntidad.contacto_direc='';
  	this.objEntidad.contacto_email='';
  	this.objEntidad.contacto_tele='';
  	this.objEntidad.beneficiario='';
  	this.objEntidad.observacion='';
  	this.objEntidad.direccion2='';
  	this.objEntidad.monto=0;
  	this.objEntidad.idtproveedor=null;
  	this.objEntidad.idsector=null;
  	this.objEntidad.idtretfte=null;
  	this.objEntidad.idtretiva=null; 
  }

  botonGrabar(){
    if(this.objEntidad.correo.trim().length == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Es necesario ingresar un correo electronico para continuar',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
      this.servicio.guardar(this.objEntidad).then((result) => 
    	{
        this.showLoader('Se guardó correctamente!!',1000);
    		this.botonNuevo();
     	}, (err) => {
         
    	});

    }
  }

  botonBuscar(){
  	const myModalOptions: ModalOptions = {
      enableBackdropDismiss: false
    };

  	this.servicio.getEntidad(this.objEntidad.idtentidad).then((result) => {
  		this.detalleBusqueda={'parametro':result, 'campobus':'identificacion,descripcion,contacto_des'};
  		let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda, myModalOptions);
  		myModal.onDidDismiss(data => {
  			if (data != null) this.objEntidad=data;
    		
  		});
    	myModal.present();
  	},
  	(err) => {

  	});
  }

  showLoader(mensaje,tiempo){
 
        this.loading = this.loadingCtrl.create({
            content: mensaje,
            duration: tiempo,
            spinner: 'hide'
        });
 
        this.loading.present();

       this.loading.onDidDismiss(() => {
          
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/entidad/entidad.ts